export default {
    namespaced: true,
    state: {
        centralList: [],
    },
    getters: {
        centralList: state => state.centralList,
    },
    mutations: {
        setCentralList(state, centralList) {
            state.centralList = centralList;
        },
    },
    actions: {
        async getCentralList({ commit }) {
            const url = Laroute.route('franchise.vue.centrals');

            try {
                const { data } = await axios.get(url);
                commit('setCentralList', data);
            } catch (e) {
                throw e;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/central.js